export interface StateInfo {
  /** URL slug, e.g. "florida" */
  slug: string;
  /** Display name, e.g. "Florida" */
  name: string;
  /** Two-letter abbreviation */
  abbr: string;
}

/**
 * States supported by location landing page templates.
 * Add entries here to scale location pages without code changes.
 */
export const STATES: StateInfo[] = [
  { slug: "florida", name: "Florida", abbr: "FL" },
  { slug: "georgia", name: "Georgia", abbr: "GA" },
  { slug: "texas", name: "Texas", abbr: "TX" },
  { slug: "north-carolina", name: "North Carolina", abbr: "NC" },
  { slug: "south-carolina", name: "South Carolina", abbr: "SC" },
  { slug: "alabama", name: "Alabama", abbr: "AL" },
];

export const STATES_BY_SLUG: Record<string, StateInfo> = Object.fromEntries(
  STATES.map((s) => [s.slug, s]),
);

/**
 * Financing slugs that support /[slug]/[state] location pages.
 * Mirrors FinancingPageData.locationEnabled but kept here for the
 * prerender route enumerator which loads this module directly.
 */
export const LOCATION_ENABLED_SLUGS: string[] = [
  "commercial-truck-financing",
  "utility-truck-financing",
  "bucket-truck-financing",
];
